
namespace RioERP.Orders {
    export class OrderGiftCardsColumns {
        static columnsKey = 'Orders.OrderGiftCards';
    }
}